import { render } from "./AuthForm.vue?vue&type=template&id=2bd044bc&scoped=true&ts=true"
import script from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthForm.vue?vue&type=script&setup=true&lang=ts"

import "./AuthForm.vue?vue&type=style&index=0&id=2bd044bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bd044bc"],['__file',"src/components/AuthForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2bd044bc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2bd044bc', __exports__)) {
    api.reload('2bd044bc', __exports__)
  }
  
  module.hot.accept("./AuthForm.vue?vue&type=template&id=2bd044bc&scoped=true&ts=true", () => {
    api.rerender('2bd044bc', render)
  })

}


export default __exports__